import * as Yup from "yup";

export const shortLink = {
  slug: Yup.string()
    .trim()
    .nullable()
    .notRequired()
    .test(
      "slug-length",
      "The short link must be between 5 and 50 characters.",
      value => !value || (value.length >= 5 && value.length <= 50)
    ),
};
